<template>
  <v-app>
    <v-app-bar app color="primary" dense dark>
      <v-app-bar-nav-icon @click.stop="$refs.drawer.toggleNavigationDrawer()" />

      <span class="title">BIKA</span>
    </v-app-bar>
    <navigation-drawer ref="drawer" />
    <!-- <transition enter-active-class="animate__animated animate__fast animate__backInRight animate__delay-1s"> -->

    <v-main style="height: 100vh" class="grey lighten-4">
      <router-view v-if="initialised" />
    </v-main>
    <g-confirmation-dialog ref="confirmationDialog" />
    <g-module-selector ref="moduleSelector" />
    <g-snackbar-alert ref="snackbarAlert" />
    <contentCreateDialog ref="contentCreateDialog" />
    <contentTextDialog ref="contentTextDialog" />
  </v-app>
</template>

<script>
  import navigation_drawer from "../components/Navigation/NavigationBar";
  import contentCreateDialog from "../views/content/maint/dialogs/contentCreateDialog";
  import contentTextDialog from "../views/content/maint/dialogs/contentTextDialog";


  export default {
    components: {
      "navigation-drawer": navigation_drawer,
      contentCreateDialog,
      contentTextDialog
    },
    data() {
      return {
        initialised: false,
      };
    },
    methods: {
      showAlert(config){
        let self = this
        self.$refs.snackbarAlert.show(config)
      }
    },
    mounted() {
      this.initialise_controllers(this, () => {
        this.initialised = true;
      });
    },
  };
</script>

<style scoped>
  .api_loading {
    width: 100%;
    position: fixed;
    top: 48px;
    z-index: 9;
  }
</style>